import { render, staticRenderFns } from "./save-translations.vue?vue&type=template&id=f7ee207e&"
import script from "./save-translations.vue?vue&type=script&lang=js&"
export * from "./save-translations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports